//The minimum time (in milliseconds) a form needs to be
//filled out before it gets send to the server.
//This is done to prevent spam.
export const MIN_FORM_FILLOUT_TIME = 2000;